export const getCategoryOrSeriesMap = (allProducts) => {
  const categories = new Map();
  const series = new Map();

  const extract = (nodes, parents = []) => {
    nodes?.forEach((node) => {
      if (node.nodes) {
        categories.set(node.key, {
          key: node.key,
          name: node.name,
          class: node.keyList,
        });
        extract(node.nodes, [...parents, node.name]);
      } else if (node.serieId) {
        series.set(node.serieId, {
          key: node.key,
          name: node.name,
          class: node.keyList,
          serieId: node.serieId,
          parentName: node.parentId,
          parentCategories: parents,
          isSerie: true,
        });
      }
    });
  };

  extract(allProducts, []);
  return [categories, series];
};

export const findKeylistBySeriesId = ({ seriesMap, productSeriesId }) => {
  const id = Number(productSeriesId);

  for (const [, item] of seriesMap) {
    if (item?.serieId === id) {
      return item.class;
    }
  }

  return [];
};

export const findSeriesKeylistByKey = ({ seriesMap, targetKey }) => {
  for (const [, item] of seriesMap) {
    if (item?.key === targetKey) {
      return item.class;
    }
  }

  return [];
};
